import React, { useEffect, useRef, useState } from "react";
import ModalPopup from "../Common/Modal/Modal";
import {
  DeleteSensCredential,
  EditSensCredential,
  ShareSensCredential,
} from "../../Api/SuperAdminVault/Credentials";
import { encryptVaultSecret } from "../Common/Encrypt-Decrypt";
import { ValidateEmailDocumentOtp } from "../../Api/SuperAdminVault/Documents";
import { ValidateOtpShareContactMail } from "../../Api/SuperAdminVault/Contacts";

const OtpModal = ({
  showOtpScreen,
  id,
  email,
  onClose,
  setShowOtpScreen,
  module,
  setEmail,
  values,
}) => {
  const [timeLeft, setTimeLeft] = useState(5 * 60); //5 * 60
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const otpRefs = useRef([]);
  useEffect(() => {
    if (!showOtpScreen) return;
    let timer;
    if (timeLeft > 0 && !showResendOtp) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setShowResendOtp(true);
    }
    return () => clearInterval(timer);
  }, [timeLeft, showResendOtp, showOtpScreen]);
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedOtp = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);
    if (!pastedOtp) return;
    const updatedOtp = ["", "", "", "", "", ""];
    pastedOtp.split("").forEach((digit, index) => {
      updatedOtp[index] = digit;
    });
    setOtp(updatedOtp);
  };
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 5) otpRefs.current[index + 1]?.focus();
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
        return;
      }
      if (index > 0) otpRefs.current[index - 1]?.focus();
    }
  };
  const handleClose = () => {
    onClose?.();
    setOtp(["", "", "", "", "", ""]);
    setShowOtpScreen(false);
    setEmail("");
  };
  const handleOtpSubmit = async () => {
    try {
      setLoading(true);
      const otpValue = otp.join("");
      const encryptedOtp = await encryptVaultSecret(otpValue);

      console.log("OTP:", otpValue);
      //Credentials
      if (module === "credentials") {
        const response = await ShareSensCredential(otpValue, id, email);

        if (response) {
          handleClose();
        }

        return;
      }
      if (module === "editCredentials") {
        const response = await EditSensCredential(encryptedOtp, values, id);
        if (response) {
          handleClose();
        }

        return;
      }
      if (module === "deleteCredentials") {
        const response = await DeleteSensCredential(id, encryptedOtp);
        if (response) {
          handleClose();
        }

        return;
      }
      // Documents
      if (module === "documents") {
        const response = await ValidateEmailDocumentOtp({
          documentId: id,
          email,
          otp: otpValue,
        });

        if (response) {
          handleClose();
        }
      }
      //Contacts
if (module === "contacts") {
  const response = await ValidateOtpShareContactMail({
    contact_id: id,
    email,
    otp: encryptedOtp,
  });
  if (response) {
    handleClose();
  }
}
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = () => {
    console.log("Resend OTP");
    setShowResendOtp(false);
    setTimeLeft(5 * 60);
  };
  return (
    <ModalPopup show={showOtpScreen} onClose={handleClose} closeicon={false}>
      <div className="space-y-4">
        <div className="flex justify-between">
          <button
            type="button"
            onClick={() => {
              setShowOtpScreen(false);
              setTimeLeft(5 * 60);
              setOtp(["", "", "", "", "", ""]);
              console.log("back pressed");
            }}
            className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
          >
            Back
          </button>
          {/* {!showResendOtp && (
            <p className="text-center text-gray-600">
              Resend OTP in {formatTime(timeLeft)}
            </p>
          )} */}
        </div>
        <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
          OTP Verification
        </h2>
        <p>Enter the 6-digit OTP sent to your registered mobile number.</p>
        <div className="flex justify-center gap-3" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (otpRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-10 h-10 border-2 border-gray-400 rounded-md p-2 text-xl text-center"
            />
          ))}
        </div>
        {/* {!showResendOtp ? ( */}
          <button
            type="button"
            disabled={otp.join("").length !== 6 || loading}
            onClick={handleOtpSubmit}
            className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md block mx-auto"
          >
            {loading ? "Verifying..." : "Verify & Share"}
          </button>
        {/* ) : (
          <button
            type="button"
            onClick={handleResendOtp}
            className="bg-[#1f4b7f] text-white px-2 py-1 rounded-md block mx-auto"
          >
            Resend OTP
          </button>
        )} */}
      </div>
    </ModalPopup>
  );
};
export default OtpModal;
